var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncallAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38647",
    "data-name": "Group 38647",
    transform: "translate(-1620 -160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2384",
    "data-name": "Ellipse 2384",
    cx: 80,
    cy: 80,
    r: 80,
    transform: "translate(1620 160)",
    fill: "rgba(255,255,255,0.24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38089",
    "data-name": "Group 38089",
    transform: "translate(2227 -1126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14680",
    "data-name": "Rectangle 14680",
    width: 88,
    height: 88,
    transform: "translate(-571 1322)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-560.45 1327.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33396",
    "data-name": "Path 33396",
    d: "M26.843,42.436A20.593,20.593,0,1,1,47.436,21.843,20.619,20.619,0,0,1,26.843,42.436Zm0-35.814A15.221,15.221,0,1,0,42.064,21.843,15.254,15.254,0,0,0,26.843,6.622Z",
    transform: "translate(6.607 -1.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33397",
    "data-name": "Path 33397",
    d: "M66.874,44.692a2.706,2.706,0,0,1-2.686-2.686c0-12.356-12.606-22.384-28.078-22.384S8.032,29.65,8.032,42.006a2.686,2.686,0,0,1-5.372,0c0-15.293,15.006-27.756,33.45-27.756S69.56,26.713,69.56,42.006A2.706,2.706,0,0,1,66.874,44.692Z",
    transform: "translate(-2.66 32.308)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncallAvatar);
export default __webpack_public_path__ + "static/media/incall-avatar.881a089f9727b486b0e3a2caab8da9c5.svg";
export { ForwardRef as ReactComponent };